import { observable }         from 'mobx';
import { makeObservable }     from 'mobx';
import { action }             from 'mobx';
import { computed }           from 'mobx';
import listFilterManagerStore from '@widesk-ui/stores/ListFilterManagerStore';
import { TableProps }         from '@widesk-ui/components/table/Table';
import devToolbarStore        from '@widesk-core/stores/devToolbarStore';
import ApiCollection          from '@widesk-core/models/ApiCollection';
import PagedCollection        from '@widesk-core/models/PagedCollection';
import _pickBy                from 'lodash/pickBy';

export default class TableStore {
	@observable private _error: any = false;
	@observable private _isLoading = true;
	@observable private _data = [];

	public collection?: ApiCollection<any> | PagedCollection<any>;

	public prevFilters: any = {};

	private _props: TableProps<any, any>;

	public constructor(props: TableProps<any, any>) {
		this._props = props;

		if (props.storageKey) {
			const filters = this.filters;
			listFilterManagerStore.set(props.storageKey, filters, props.urlStorageEnabled);
		}

		makeObservable(this);
	}

	public setProps(props: TableProps<any, any>) {
		this._props = props;
	}

	@action setIsLoading(value: boolean) {
		this._isLoading = value;
	}

	@action setError(value: any) {
		this._error = value;
	}

	@action setData(data: []) {
		this._data = data;
	}

	@computed get isLoading() {
		return this._isLoading;
	}

	@computed get error() {
		return this._error;
	}

	@computed get data() {
		return this._data;
	}

	public reload() {
		devToolbarStore.clearRequests();

		return this.fetch(this.page, this.pageSize, this.prevFilters);
	}

	public async fetch(page: number, step: number, filters: Record<string, unknown>) {
		try {
			this.setIsLoading(true);
			this.setError(false);

			const data = await this._props.fetch(page, step, filters);

			if (this._props.storageKey) {
				listFilterManagerStore.set(
					this._props.storageKey,
					{ ...filters, page, step },
					this._props.urlStorageEnabled
				);
			}

			this.setData(data);

			return data;
		} catch (e) {
			this.setError(e);

			throw e;
		} finally {
			this.prevFilters = filters;
			this.setIsLoading(false);
		}
	}

	public get filters() {
		// Chargement des filtres dans le localStorage
		const filters = this._props.storageKey ?
			listFilterManagerStore.get(this._props.storageKey, this._props.urlStorageEnabled) :
			this.prevFilters;

		// S'il n'y a pas de filtre
		if (!Object.keys(filters).filter(key => !['page', 'step'].includes(key)).length) {
			// On utilise les filtres par défaut
			return this._props.defaultFilters || {};
		}

		return filters;
	}

	public get sorts() {
		return _pickBy(this.filters, (_, key) => key.startsWith('order['));
	}

	public get page() {
		return this.filters.page as number || 1;
	}

	public get pageSize() {
		return (this._props.pagination && this._props.pagination.pageSize)
			|| this.filters.step as number
			|| 10;
	}

	public get total() {
		const pagination = (this._props.pagination as any);
		if (pagination?.pagedCollection) {
			return pagination.pagedCollection.total || 0;
		}

		return 0;
	}
}
